import React, { useContext } from 'react'
import QuizSectionTemplate from '../QuizSectionTemplate'
import Explaination from '../Explaination'
import { Flex, Select } from '@mantine/core'
import QuizParameterTemplate from '../QuizParameterTemplate'
import { QuizContext } from '@context/QuizContext'
import RoundButton from '@components/button/RoundButton'
import accounting from 'accounting'
import BackButton from '../BackButton'
import QuizTooltip from '../QuizTooltip'
const QuizSectionThree = () => {
    const {
        form3,
        nextStep,
        currentStep,
        retirement_age,
        amount_retirement_years,
        payment_at_retirement_first_year,
        rate_return_after_retirement_with_inflation,
        required_funds_for_retirement,
    } = useContext(QuizContext)
    if (currentStep !== 3) {
        return <></>
    }

    return (
        <form onSubmit={form3!.onSubmit(() => nextStep!())}>
            <Explaination />
            <QuizSectionTemplate
                section={3}
                title='ประมาณการเงินทุนเพื่อการเกษียณที่ต้องการ'
            >
                <QuizParameterTemplate
                    afterLabel='% ต่อปี'
                    label='สมมุติฐานอัตราเงินเฟ้อระยะยาว'
                    required
                >
                    <QuizTooltip label='ระหว่าง 2.00% - 3.50% ต่อปี'>
                        <Select
                            w={200}
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                    textAlign: 'end',
                                },
                            }}
                            data={[
                                { label: '2.00%', value: '2.00' },
                                { label: '2.50%', value: '2.50' },
                                { label: '3.00%', value: '3.00' },
                                { label: '3.50%', value: '3.50' },
                            ]}
                            min={50}
                            max={65}
                            style={{}}
                            {...form3!.getInputProps(
                                'long_term_inflation_assumption'
                            )}
                        />
                    </QuizTooltip>
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='บาท/ปี'
                    label={`ค่าใช้จ่าย ณ ปีแรกที่เกษียณ ณ อายุ ${retirement_age} ปี - ปรับด้วยเงินเฟ้อ`}
                    type='value'
                >
                    {accounting.formatMoney(payment_at_retirement_first_year!, {
                        symbol: '',
                        precision: 2,
                    }) ?? 0}
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='ปี'
                    label='ประมาณการอายุขัยสุดท้าย'
                    required
                >
                    <QuizTooltip label='ไม่ต่ำกว่า 85 ปี'>
                        <Select
                            w={200}
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                    textAlign: 'end',
                                },
                            }}
                            data={[
                                { label: '80', value: '80' },
                                { label: '85', value: '85' },
                                { label: '90', value: '90' },
                                { label: '95', value: '95' },
                                { label: '100', value: '100' },
                                { label: '110', value: '110' },
                                { label: '120', value: '120' },
                            ]}
                            {...form3!.getInputProps('estimated_final_age')}
                        />
                    </QuizTooltip>
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='ปี'
                    label={`ระยะเวลาหลังเกษียณ`}
                    type='value'
                >
                    {isNaN(amount_retirement_years!)
                        ? 0
                        : amount_retirement_years!}
                </QuizParameterTemplate>

                <QuizParameterTemplate
                    afterLabel='% ต่อปี'
                    label='ประมาณการอัตราผลตอบแทนหลังเกษียณ'
                    description='(ไม่ต้องคำนึงถึงเงินเฟ้อ)'
                    required
                >
                    <QuizTooltip label='ระหว่าง 2.50% - 5.00% ต่อปี'>
                        <Select
                            w={200}
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                    textAlign: 'end',
                                },
                            }}
                            data={[
                                { label: '2.50%', value: '2.50' },
                                { label: '3.00%', value: '3.00' },
                                { label: '3.50%', value: '3.50' },
                                { label: '4.00%', value: '4.00' },
                                { label: '4.50%', value: '4.50' },
                                { label: '5.00%', value: '5.00' },
                            ]}
                            {...form3!.getInputProps(
                                'estimated_rate_return_after_retirement'
                            )}
                            value={String(
                                form3!.getInputProps(
                                    'estimated_rate_return_after_retirement'
                                ).value
                            )}
                        />
                    </QuizTooltip>
                </QuizParameterTemplate>

                <QuizParameterTemplate
                    afterLabel='% ต่อปี'
                    label={`อัตราผลตอบแทนหลังเกษียณ - ปรับด้วยเงินเฟ้อ`}
                    type='value'
                >
                    {isNaN(rate_return_after_retirement_with_inflation!)
                        ? 0
                        : rate_return_after_retirement_with_inflation!.toFixed(
                              4
                          )}
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='บาท'
                    label={`เงินทุนเพื่อการเกษียณอายุทั้งหมดที่ต้องมี ณ ปีที่เกษียณอายุ`}
                    type='conclude'
                >
                    {accounting.formatMoney(required_funds_for_retirement!, {
                        symbol: '',
                        precision: 2,
                    }) ?? 0}
                </QuizParameterTemplate>
            </QuizSectionTemplate>
            <Flex
                mb='xl'
                direction={{ xs: 'column', sm: 'row' }}
                gap='lg'
                justify={{ xs: 'center', sm: 'space-between' }}
            >
                <BackButton />
                <RoundButton type='submit' label='ถัดไป' />
            </Flex>
        </form>
    )
}

export default QuizSectionThree
